module.exports = __webpack_public_path__ + "static/BoatTrack-b1154564878d7aab70adb09ca453e110.png";